import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SequenceEventsSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type SequenceEventsSubscription = { __typename?: 'Subscription', sequenceEvents: { __typename?: 'SequenceActivatedPayload', sequenceId: string, sequenceName: string } | { __typename?: 'SequenceClosedPayload', sequenceId: string } | { __typename?: 'SequenceEncodeCanceledPayload', id: string } | { __typename?: 'SequenceEncodeCompletePayload', id: string, filePath: string } | { __typename?: 'SequenceEncodeProgressErrorPayload', id: string, message: string } | { __typename?: 'SequenceEncodeProgressPayload', id: string, progress?: number | null } | { __typename?: 'SequenceUploadJobItemProgressPayload', assetId: string, bytesSent?: number | null, bytesTotal?: number | null, filePath: string, percentage?: number | null, remainingTime?: number | null, state?: Types.PremiereTransferState | null } | { __typename?: 'SequenceUploadJobProgressPayload', id: string, jobId?: string | null, state?: Types.PremiereTransferState | null, progress?: number | null, bytesSent?: number | null, bytesTotal?: number | null, percentage?: number | null, failedItems?: number | null, completedItems?: number | null, totalItems?: number | null } };


export const SequenceEvents = /*#__PURE__*/ gql`
    subscription SequenceEvents {
  sequenceEvents {
    ... on SequenceEncodeProgressPayload {
      id
      progress
    }
    ... on SequenceEncodeCompletePayload {
      id
      filePath
    }
    ... on SequenceEncodeProgressErrorPayload {
      id
      message
    }
    ... on SequenceEncodeCanceledPayload {
      id
    }
    ... on SequenceUploadJobProgressPayload {
      id
      jobId
      state
      progress
      bytesSent
      bytesTotal
      percentage
      failedItems
      completedItems
      totalItems
    }
    ... on SequenceUploadJobItemProgressPayload {
      assetId
      bytesSent
      bytesTotal
      filePath
      percentage
      remainingTime
      state
    }
    ... on SequenceActivatedPayload {
      sequenceId
      sequenceName
    }
    ... on SequenceClosedPayload {
      sequenceId
    }
  }
}
    ` as unknown as DocumentNode<SequenceEventsSubscription, SequenceEventsSubscriptionVariables>;

          

          export const useSequenceEventsSubscription = (options?:SubscriptionHookOptions<SequenceEventsSubscription, SequenceEventsSubscriptionVariables>) => useSubscription(SequenceEvents, options);

          

          export type SequenceEventsSubscriptionOptions = SubscriptionHookOptions<SequenceEventsSubscription, SequenceEventsSubscriptionVariables>;

          

          export type SequenceEventsSubscriptionResult = ReturnType<typeof useSequenceEventsSubscription>;

          
